<template>
	<div>
		<div style="overflow-x: auto;padding: 5px 0;" class="d-flex justify-center">
			<div id="printHtmlContract" v-if="auth"
				style="border: 1px solid #ccc;background-color: white;padding: 10px;color: #000;width: 190mm;"
				class="my-5">
				<div v-html="auth.memberDescription" class="content">
				</div>
				<div class="mt-2 text-justify contract" v-if="auth.tag" v-html="auth.tag">
				</div>
			</div>
		</div>
		<v-row class="justify-center">
			<v-col cols="12" md="8" xl="4">
				<div v-if="auth.status === 20" class="" style="">
					<v-alert type="success" icon="mdi-check-circle" outlined>
						قرارداد قبلا امضا شده است.
					</v-alert>
					<div class="mt-2 text-justify contract" v-if="auth.tag" v-html="auth.tag">
					</div>
				</div>
				<v-card v-else-if="!successSigned" color="#f5f5f5" class="pa-3" elevation="0" style="width: 100%">
					<div>کاربر گرامی به منظور امضای دیجیتال قرارداد، بر روی دکمه "ارسال کد" بزنید و کد ارسالی را در باکس
						زیر وارد نمایید:</div>
					<div class="d-flex flex-wrap justify-center mt-2 align-center">
						<v-text-field style="max-width: 160px;" v-model="mobileOtp" maxlength="5" label="کد تایید"
							:rules="[() => !!mobileOtp || 'الزامی']" required />
						<v-btn v-if="sendCodeVisible" color="success" outlined small class="mx-2 mt-3" @click="sendOTP"
							:loading="otpLoading">ارسال کد {{ mobile ? `(${mobile})` : '' }}</v-btn>
						<Countdown class="secondary--text fs-h3 mt-3" style="text-align: center;"
							@finish="countDownFinished" ref="countdown" />
						<v-btn :disabled="!canSign && false" color="success" elevation="0" small class="mx-2 mt-3"
							@click="verifyOtp" :loading="verifyOtpLoading">ثبت کد و امضا قرارداد</v-btn>
					</div>
				</v-card>
				<v-slide-y-transition :hide-on-leave="true">
					<v-alert v-if="successSigned" type="success" icon="mdi-file-sign" outlined>
						تبریک، قرارداد با موفقیت امضا شد.
					</v-alert>
				</v-slide-y-transition>
			</v-col>
		</v-row>

		<div>
			<v-row class="justify-center"
				v-if="auth.status !== 20 && ['admin', 'agent'].includes(area) && !successSigned">
				<v-col cols="12" md="4" xl="4" class="pb-0">
					<v-btn block small color="secondary" text :loading="sendLinkLoading" @click="sendLink">
						<v-icon left>mdi-cellphone-text</v-icon>
						ارسال لینک قرارداد {{ mobile ? `(${mobile})` : '' }}
					</v-btn>
				</v-col>
			</v-row>
			<v-row class="justify-center">
				<v-col cols="12" md="4" xl="4">
					<v-btn block small color="secondary" text @click="print()">
						<v-icon left>mdi-printer-outline</v-icon>
						چاپ قرارداد
					</v-btn>
				</v-col>
			</v-row>
		</div>

	</div>
</template>

<script>
	import api from '@/util/app-api'
	import { get } from 'vuex-pathify'
	import toast from '@/util/toast'
	import { auth } from '@/store/modules'
	import printJS from 'print-js'

	export default {
		name: 'Contract',
		props: {
			auth: { type: Object, default: null },
			area: { type: String, default: '' },
			mobile: { type: String, default: '' },
		},
		data() {
			return {
				canSign: false,
				mobileOtp: '',
				sendCodeVisible: true,
				otpLoading: false,
				verifyOtpLoading: false,
				sendLinkLoading: false,
				successSigned: false,
			}
		},
		components: {
			Countdown: () => import('@/components/Countdown')
		},
		computed: {

		},
		mounted() {

		},
		methods: {
			countDownFinished() {
				this.sendCodeVisible = true
			},
			sendOTP() {
				if (!this.mobile) {
					toast.error('شماره موبایل وارد نشده است')
					return
				}
				this.otpLoading = true
				api.post(`account/SendDigitalSignOTP/${this.mobile}?customerCode=${this.$route.params.ccode || 0}&id=${this.auth.id}`, {}, { authHeader: false, contentType: 'application/json' })
					.then(response => {
						this.sendCodeVisible = false
						this.canSign = true
						this.$refs.countdown.start()
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.otpLoading = false
					})
			},
			sendLink() {
				this.sendLinkLoading = true
				api.post(`${this.area}/AppSms/SendDigitalSignLink?id=` + this.auth.id, {})
					.then(response => {
						toast.success('پیامک با موفقیت ارسال شد.')
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.sendLinkLoading = false
					})
			},
			verifyOtp() {
				if (!this.mobileOtp) {
					toast.error('کد تاییدیه وارد نشده است.')
					return
				}
				this.verifyOtpLoading = true
				const data = {
					id: this.auth.id,
					customerCode: this.auth.customerCode || null,
					otp: this.mobileOtp
				}
				api.post(`${this.area}${this.area ? '/' : ''}UserLoanRequestAuthorizationItem/SignContractWithOtp`, data, { authHeader: !!this.area, contentType: 'application/json' })
					.then(response => {
						this.successSigned = true
						this.$emit('updated')
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.verifyOtpLoading = false
					})
			},
			print() {
				printJS({
					printable: 'printHtmlContract',
					type: 'html',
					scanStyles: false, // If true inline styles will be removed
					targetStyles: ['*'],
					style: `
										@font-face {
											font-family:'YekanP';
											src:url(/iranyekanweb.ttf) format('truetype'),
											url(/iranyekanweb.woff) format('woff-variations'),
											url(/iranyekanweb.woff) format('woff'),
											url(/iranyekanweb.woff2) format('woff2');
											font-display:fallback
										}
										#printHtmlContract {
											display: block !important;
											font-family: 'YekanP', sans-serif;
											direction: rtl;
										}
										#printHtmlContract .contract{
											display: block;
											font-size: 9px;
										}
										#printHtmlContract .content{
											display: block;
											font-size: 9px!important;
										}
									`
				})
			}
		}
	}
</script>
<style scoped>
	@font-face {
		font-family: 'YekanP';
		src: url('/iranyekanweb.woff') format('woff-variations'),
			url('/iranyekanweb.woff') format('woff'),
			url('/iranyekanweb.woff2') format('woff2');
		font-display: fallback
	}

	#printHtmlContract {
		font-size: 12px;
	}

	.contract b {
		font-weight: 900;
		border-bottom: 1px dotted blue;
		color: blue;
	}

	#printHtmlContract .contract {
		display: none;
	}
</style>
